import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { SpecialTool, SpecialToolExcelData, Vehicaltype } from '../../../business-entities/special-tool-model';
import { SpecialToolBusinessService } from '../../../business-services/special-tool.service'
import { ExcelService } from '../../../../../../Autofacets-Core/src/app/common-services/export-excel.service'
import { jsPDF } from "jspdf";
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { CurrentLanguage } from './../../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import html2canvas from 'html2canvas';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import { EditSpecialToolComponent } from '../edit-special-tool/edit-special-tool/edit-special-tool.component';
import { AddSpecialToolComponent } from '../add-special-tool/add-special-tool/add-special-tool.component';
import { VehicleType } from '../../../business-entities/vehicle-list-view-model';
import { CheckListBusinessService } from 'projects/Administration/src/app/business-services/check-list.service';
@Component({
  selector: 'app-special-tool',
  templateUrl: './special-tool.component.html',
  styleUrls: ['./special-tool.component.css']
})
export class SpecialToolComponent implements OnInit, OnDestroy {
  @ViewChild('content') content: ElementRef;
  language: string;
  total$: Observable<number>;
  specialToolList: SpecialTool[];
  excelExportData: SpecialToolExcelData[];
  popupCloseResult = false;
  fileName = 'ExcelSheet.xlsx';
  SelectedVehical: any;
  paginationSub: Subscription
  currentlagSub: Subscription
  currentDateTime: Promise<Date>;
  vehicalTypes: Vehicaltype = {
    PC: false,
    LCV: false,
    Truck: false,
  };
  userRoleRightsDetails: UserRoleMenu;
  vehicleTypes: VehicleType[] = [];
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    private specialToolService: SpecialToolBusinessService,
    public pService: CustomPaggerService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private excelService: ExcelService,
    private router: Router,
    private cookieservice: CookieService,
    private currentLanguageService: CurrentLanguage,
    private cd: ChangeDetectorRef,
    private userService: UserDataService,
    private checkListService: CheckListBusinessService
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['brand', 'partNumber', 'partDescription', 'partGroup'];
    this.pService.searchTerm = '';

  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.currentlagSub.unsubscribe();
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
  }
  vehicalType = [
    { id: 1, name: 'PC', value: true },
    { id: 2, name: 'LCV', value: true },
    { id: 3, name: 'Truck/Bus', value: true },
  ];
  ngOnInit(): void {
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === fromEnums.ModuleNames.SpecialTools);
    this.pService.dataSource = [];
    this.cd.detectChanges();
    if (this.currentlagSub) {
      this.currentlagSub.unsubscribe();
    }
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(_x => {
      this.GetAllVehicleTypes();
      this.getSpecialToolList(this.SelectedVehical);

    });
    setInterval(() => {
      this.currentDateTime =  Promise. resolve(new Date());
    }, 1000);
  }
  async GetAllVehicleTypes(): Promise<void> {
    await this.checkListService.getVehicleTypes().then(data => {
      if(localStorage.getItem("Theme") == Constant.BnhInterface){
        this.vehicleTypes = data.responseObject;
      }
      else{
        this.vehicleTypes = data.responseObject.filter(x => x.isDisplay);
      }
    });
  }
  SerchByVehicalType() {
    this.getSpecialToolList(this.SelectedVehical);
  }

  async getSpecialToolList(vehicalObj: Vehicaltype) {
    this.spinner.show();
    let language = this.cookieservice.get('userSelectedLanguage')
     let requestObj=
     {
      vehicleTypes:vehicalObj?.toString(),
       LANGUAGECODE:language
     }
    await this.specialToolService.getSpecialToolList(requestObj).then((response) => {
      this.excelExportData = this.ExcelDataMapping(response);
      this.pService.dataSource = response;
      this.paginationSub = this.pService.dealers$.subscribe(result => {
        this.specialToolList = this.specialToolMapping(result);
      });
    })
    this.spinner.hide();
  }
  onEdit(id: number) {
    this.specialToolService.SpecialToolId = id
    const modalref = this.modalService.open(EditSpecialToolComponent, { size: 'md', windowClass: 'EditPopup' });
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
      });
  }
  private ExcelDataMapping(manualList: any) {
    let supperArray = [];
    if (manualList && manualList.length > 0) {
      manualList.forEach(element => {
        let single = Object();
        single.Brand = element.brand;
        single.PartNumber = element.partNumber;
        single.partDescription =element.partDescription;
        single.PartGroup = element.partGroup;
        single.vehicleType = element.vehicleType;
        single.type = element.type;
        supperArray.push(single);
      })
    }
    return supperArray;
  }
  private specialToolMapping(manualList: any) {
    let supperArray = [];
    if (manualList && manualList.length > 0) {

      for (let index = 0; index < manualList.length; index++) {
        const element = manualList[index];

        let single = Object();
        single.rowNumber = this.currentPageNumber(index);
        single.id = element.id;
        single.brand = element.brand;
        single.brandId = element.brandId;
        single.createdBy = element.createdBy;
        single.createdDate = element.createdDate;
        single.updatedBy = element.updatedBy;
        single.updatedDate = element.updatedDate;
        single.partDescription =element.partDescription;
        single.partGroup = element.partGroup;
        single.partImage = element.partImage === null ? './../../../assets/images/no-img.png' : element.partImage;
        single.partNumber = element.partNumber;
        single.vehicleType = element.vehicleType;
        single.type = element.type;
        supperArray.push(single);
      }
    }
    return supperArray;
  }
  onAdd() {
    const modalref = this.modalService.open(AddSpecialToolComponent, { size: 'md', windowClass: 'EditPopup' });
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
      });
  }
  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.excelExportData, 'Special Tool Report');
  }
  generatePDF() {
    let data = document.getElementById('content');
    html2canvas(data).then(canvas => {
      let imgWidth = 208;
      let imgHeight = canvas.height * imgWidth / canvas.width;
      const contentDataURL = canvas.toDataURL('image/png')
      let pdf = new jsPDF('p', 'mm', 'a4');
      let position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight)
      pdf.save('newPDF.pdf');
    });
  }
  deleteSpecialTool(id: number) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"),this.translate.instant("lblSpecialTools"),true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.specialToolService.deleteSpecialTool(id).then((response) => {
          if (response.responseCode == Constant.SuccessResponseCode) {
            let deletedmsg = this.translate.instant("lblSpecialToolDeleted");
            this.toastr.success(deletedmsg)
            this.getSpecialToolList(this.SelectedVehical);
          }
        });
      }
    });
  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  /**
* Method to generate auto row number based on per page size
* @param cIndex
*/
  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    }
    else if (this.pService.page > 1) {
      rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
    }

    return rtPageNumber;
  }
}
